import type { SVGProps } from "react"
import * as React from "react"

const SvgAndroidRobot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1274.37 718"
    fill="currentColor"
    width={20}
    height={20}
    {...props}
  >
    <path d="M930.77 536.42a53.07 53.07 0 1 1 53.06-53.08 53.14 53.14 0 0 1-53.06 53.08m-586.54 0a53.07 53.07 0 1 1 53.06-53.08 53.13 53.13 0 0 1-53.06 53.08M949.8 216.77l106.05-183.68A22.06 22.06 0 1 0 1017.64 11L910.25 197c-82.12-37.48-174.35-58.35-272.76-58.35S446.86 159.55 364.74 197L257.36 11a22.06 22.06 0 1 0-38.22 22.06L325.2 216.77C143.09 315.82 18.53 500.18.31 718h1274.38c-18.24-217.82-142.79-402.18-324.89-501.23" />
  </svg>
)
export default SvgAndroidRobot
